exports = module.exports = require("../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main_loader {\n    display: flex;\n    justify-content: center;\n    position:fixed;\n    top:0;\n    left:0;\n    width:100%;\n    z-index:8;\n    height: 100%;\n}\n.overlay{\n    position:fixed;\n    top:0;\n    left:0;\n    width:100%;\n    background-color: rgba(0,0,0,0.3);\n    z-index:8;\n    height: 100%;\n  }\n\n.content{\n    display: flex;\n    align-items: center;\n    position: relative;\n    max-width: 420px;\n    margin:10% auto;\n    z-index: 9;\n}\n \n\n \n\n\n  \n  ", ""]);

// exports
